export default __webpack_public_path__ + "assets/images/3d00742765950d234da5fdfe5eefaee9.png";